import React from 'react'
import PropTypes from 'prop-types'
import Countdown from 'react-countdown'
import cx from 'classnames'

const EventCountdown = ({ startTime, hostName, eventDate, onMobile }) => (
  <Countdown
    renderer={({ days, hours, minutes, seconds, completed }) => {
      return (
        <span className={cx('text-white', onMobile && 'text-lg pt-1 mr-1')}>
          {completed
            ? `Invited by ${hostName}`
            : days
            ? `${eventDate.format('ddd MMM D, h:mm a')}`
            : hours
            ? `${hours}h ${minutes}m ${seconds}s`
            : minutes
            ? `${minutes}m ${seconds}s`
            : `${seconds}s`}
        </span>
      )
    }}
    date={startTime}
  />
)

EventCountdown.propTypes = {
  startTime: PropTypes.string,
  hostName: PropTypes.string,
  eventDate: PropTypes.object,
  onMobile: PropTypes.bool,
}

EventCountdown.defaultProps = {
  onMobile: false,
}

export default EventCountdown
